"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteNavLargeLinks = void 0;
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const lodash_throttle_1 = __importDefault(require("lodash.throttle"));
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const window_or_global_1 = __importDefault(require("window-or-global"));
const shared_1 = require("../../shared");
const utils_1 = require("../../utils");
const enhanced_1 = require("../enhanced");
const menu_1 = require("../menu");
const SiteNavSummaryLink_1 = require("./SiteNavSummaryLink");
const Styled = styled_components_1.default.div `
	height: 100%;
	display: flex;
	align-items: center;
	text-align: center;
	&.search-open {
		display: none;
	}
`;
const SiteNavLargeLinks = ({ links = [], activeLink, collapseTargetMaxWidth = 1680, locale, topOffset, }) => {
    const collapsedMode = (0, epic_games_nav_shared_1.useCollapsedMode)();
    const [collapsedCanFit, setCollapsedCanFit] = (0, react_1.useState)(false);
    const searchOpen = (0, shared_1.useSearchOpenStatic)();
    /**
     * The prop collapseTargetMaxWidth can be used to set a maximum browser width to render the collapsed menu.
     * All widths above the collapseTargetMaxWidth will render the full desktop mode.
     */
    const checkCollapsedFit = (0, react_1.useCallback)(() => {
        if (window_or_global_1.default.__server_side_render || !collapsedMode || !collapseTargetMaxWidth)
            return;
        const innerWidth = (0, epic_games_nav_shared_1.getInnerWidth)();
        if (innerWidth && innerWidth > collapseTargetMaxWidth) {
            setCollapsedCanFit(true);
        }
        else {
            setCollapsedCanFit(false);
        }
    }, [collapsedMode, collapseTargetMaxWidth, setCollapsedCanFit, window_or_global_1.default.__server_side_render]);
    const throttleCheck = (0, lodash_throttle_1.default)(checkCollapsedFit, 500, { leading: false });
    (0, react_1.useEffect)(() => {
        checkCollapsedFit();
        window_or_global_1.default.addEventListener("resize", throttleCheck);
        return () => {
            throttleCheck.cancel();
            window_or_global_1.default.removeEventListener("resize", throttleCheck);
        };
    }, [checkCollapsedFit, throttleCheck]);
    let collapsed = false;
    if (collapsedMode && !collapsedCanFit) {
        collapsed = true;
    }
    const largeUpLinks = links.map((link, i) => {
        const isEnhancedDropdown = (0, utils_1.isValidEnhancedDropdown)(link);
        const hasKids = Boolean(link.kids && link.kids.length);
        const menuId = link.key || `menu-${i}`;
        const linkEl = (react_1.default.createElement(SiteNavSummaryLink_1.SiteNavSummaryLink, { key: `large-summary-${menuId}`, link: link, activeLink: activeLink, locale: locale }));
        if (collapsed && link.collapseTarget) {
            return null;
        }
        else if (isEnhancedDropdown) {
            return (react_1.default.createElement(enhanced_1.EnhancedDesktopDropdownMenu, { key: `enhanced-${menuId}`, summaryNode: linkEl, enhancedDrodown: link.enhancedDropdown, links: link.kids, menuId: menuId, locale: locale }));
        }
        else if (hasKids) {
            return (react_1.default.createElement(menu_1.SimpleDesktopDropdownMenu, { key: `simple-${menuId}`, summaryNode: linkEl, links: link.kids, menuId: menuId }));
        }
        return react_1.default.createElement(menu_1.SoloDesktopDropdownMenu, { key: `solo-${menuId}`, summaryNode: linkEl, menuId: menuId });
    });
    const collapsedLinksMap = {};
    if (collapsed) {
        links.map((link) => {
            if (link.collapseTarget) {
                if (!collapsedLinksMap[link.collapseTarget]) {
                    collapsedLinksMap[link.collapseTarget] = [];
                }
                collapsedLinksMap[link.collapseTarget].push(link);
            }
        });
        Object.keys(collapsedLinksMap).map((key, i) => {
            const menuId = key || `menu-${largeUpLinks.length + i}`;
            largeUpLinks.push(react_1.default.createElement(menu_1.CollapsedDropdownMenu, { key: `collapsed-${key}`, summaryNode: react_1.default.createElement(SiteNavSummaryLink_1.SiteNavSummaryLink, { key: `collapsed-summary-${key}`, link: { title: key }, activeLink: activeLink, locale: locale }), links: collapsedLinksMap[key], menuId: menuId, locale: locale, topOffset: topOffset }));
        });
    }
    return react_1.default.createElement(Styled, { className: `large-links ${searchOpen ? "search-open" : ""}` }, largeUpLinks);
};
exports.SiteNavLargeLinks = SiteNavLargeLinks;
//# sourceMappingURL=SiteNavLargeLinks.js.map